import { store } from '../../../boot-client';
import { SET_DIALOG_TOAST, DialogToastVariant, DialogToastDefaultDurationMs } from './constants';

export const showDialogToast = (
    message,
    variant = DialogToastVariant.INFO,
    durationMs = DialogToastDefaultDurationMs,
    animateProgress = false,
    showCloseIcon = false
) => {
    store.dispatch({ type: SET_DIALOG_TOAST, data: { message, variant, durationMs, animateProgress, showCloseIcon } });
};
